import type { Entity } from '@shared/data/entity';
import { createCtx } from '@shared/util/context';

export interface EntitySelectionContextValue {
  selectedEntities: Entity[];
  selectedCount: number;
  addEntity(entity: Entity): void;
  removeEntity(id: string): void;
  toggleEntity(entity: Entity): void;
  isEntitySelected(id: string): boolean;
  selectionActive: boolean;
  reset(): void;
  loading: boolean;
  startLoading(): void;
  stopLoading(): void;
}

export const [useEntitySelection, EntitySelectionContextProvider] =
  createCtx<EntitySelectionContextValue>();
